const AGENT_URL = 'http://127.0.0.1:47800'

export type CardData = {
  status: 'ok'
  cid: string
  titleTh?: string
  firstNameTh: string
  lastNameTh: string
  titleEn?: string
  firstNameEn?: string
  lastNameEn?: string
  dob?: string
  gender?: 'M' | 'F'
  address?: string
  photo?: string
}

export type AgentResponse =
  | CardData
  | { status: 'waiting' }
  | { status: 'error'; message: string }

export async function checkAgentHealth(signal?: AbortSignal): Promise<boolean> {
  try {
    const res = await fetch(`${AGENT_URL}/health`, { signal })
    return res.ok
  } catch {
    return false
  }
}

export async function readCardOnce(signal?: AbortSignal): Promise<AgentResponse> {
  const res = await fetch(`${AGENT_URL}/card/read`, { signal })
  if (!res.ok) throw new Error(`AGENT_HTTP_${res.status}`)
  return (await res.json()) as AgentResponse
}

// Poll the agent every `intervalMs` until we get an `ok` or `error` status,
// up to `timeoutMs`. Returns the final CardData or throws.
export async function pollCard(
  opts: { intervalMs?: number; timeoutMs?: number; signal?: AbortSignal } = {},
): Promise<CardData> {
  const intervalMs = opts.intervalMs ?? 1000
  const timeoutMs = opts.timeoutMs ?? 30_000
  const started = Date.now()
  while (true) {
    if (opts.signal?.aborted) throw new Error('ABORTED')
    if (Date.now() - started > timeoutMs) throw new Error('AGENT_TIMEOUT')
    try {
      const r = await readCardOnce(opts.signal)
      if (r.status === 'ok') return r
      if (r.status === 'error') throw new Error(r.message || 'AGENT_ERROR')
    } catch {
      // waiting or transient error — retry
    }
    await new Promise((r) => setTimeout(r, intervalMs))
  }
}
